// @ts-expect-error untyped file
import translatePayments from 'FormsUI/actions/FormDefinition/translatePayments';
// @ts-expect-error untyped file
import translateThankYouMessage from 'FormsUI/actions/FormDefinition/translateThankYouMessage';
// @ts-expect-error untyped file
import translateLegalConsent from 'FormsUI/actions/FormDefinition/translateLegalConsent';
import { fetchAdConsentLabel } from 'FormsUI/actions/AdConsent';
import { hasAdConsentAccess } from 'FormsUI/selectors/AdConsentAccess';
const createAction = name => `@@formDefinition/${name}`;
export const START_UPDATE_FORM_LANGUAGE = createAction('START_UPDATE_FORM_LANGUAGE');
export const END_UPDATE_FORM_LANGUAGE = createAction('END_UPDATE_FORM_LANGUAGE');
const updateFormLanguage = (oldLocale, newLocale) => (dispatch, getState) => {
  const state = getState();
  const adConsentAccess = hasAdConsentAccess(state);
  dispatch({
    type: START_UPDATE_FORM_LANGUAGE,
    oldLocale,
    newLocale
  });
  dispatch(translatePayments(oldLocale, newLocale));
  dispatch(translateThankYouMessage(oldLocale, newLocale));
  dispatch(translateLegalConsent(oldLocale, newLocale));
  if (adConsentAccess) {
    dispatch(fetchAdConsentLabel(newLocale));
  }
  dispatch({
    type: END_UPDATE_FORM_LANGUAGE,
    oldLocale,
    newLocale
  });
};
export default updateFormLanguage;